import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useLazyQuery, gql, useReactiveVar } from '@apollo/client'

import { EditableComponent } from '../components'
import { apolloAuthData, getEditStatus } from '../services/apollo'
import { ROLE_MANAGER } from '../constants'
import { ReactComponent as HourGlassImage } from '../assets/images/hourglass.svg'

const GET_HOME_SECTION1 = gql`
  query HomePages {
    homePages(first: 1) {
      edges {
        node {
          databaseId
          section1 {
            title
            content
          }
        }
      }
    }
  }
`

const HomeSection1 = () => {
  const auth = useReactiveVar(apolloAuthData)
  const isManager = auth.user?.capabilities?.includes(ROLE_MANAGER)
  let [searchParams] = useSearchParams()
  const isEditOn = isManager && !!searchParams.get('edit')
  const [getHomeSection1, { loading, error, data }] = useLazyQuery(
    GET_HOME_SECTION1,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const homePageData = data?.homePages?.edges[0]?.node ?? null
  const section1Data = homePageData?.section1 ?? null

  useEffect(() => {
    if (!isEditOn && getEditStatus().changes.length === 0) {
      getHomeSection1()
    }
  }, [isEditOn, getHomeSection1])

  // Load data every time the page is loaded with edit mode on
  useEffect(() => {
    if (isEditOn) {
      getHomeSection1()
    }
  }, [isEditOn, getHomeSection1])

  return (
    <div className="md:grid-rows-0 container relative -mt-[40px] grid max-w-screen-home grid-rows-none place-items-center md:mt-0 md:grid-cols-2 md:justify-items-end xl:grid-cols-3 xl:px-0">
      {loading || !data ? (
        <></>
      ) : (
        <div>
          <h1 className="mb-4 text-4xl font-bold text-skin-accent">
            {/** Title */}
            {isEditOn ? (
              <EditableComponent
                editable={isEditOn}
                doc={section1Data?.title ?? '<div></div>'}
                toolbarOption={{
                  bold: false,
                  listNumber: false,
                  listBullet: false,
                }}
                tag={{
                  page: 'HOME_PAGE',
                  type: 'section1Title',
                  databaseId: homePageData?.databaseId,
                  action: 'update',
                }}
                disableParagraph={true}
              />
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: section1Data?.title ?? '<div></div>',
                }}
              />
            )}
          </h1>
          {/** Content */}
          {isEditOn ? (
            <EditableComponent
              editable={isEditOn}
              doc={section1Data?.content ?? '<div></div>'}
              tag={{
                page: 'HOME_PAGE',
                type: 'section1Content',
                databaseId: homePageData?.databaseId,
                action: 'update',
              }}
            />
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: section1Data?.content ?? '<div></div>',
              }}
            />
          )}
        </div>
      )}
      <div className="row-start-1 mb-2 mt-0 md:row-start-auto md:-mt-[75px] md:mb-0 xl:col-span-2 xl:col-start-2">
        <HourGlassImage className="h-[250px] lg:h-[350px] xl:h-[570px]" />
      </div>
    </div>
  )
}

export default HomeSection1
